<template>
  <div class="topten">
    <!-- <h1>This is the TopTen page</h1> -->

    <div class="myheaderbar">
      <h1>TOP 10</h1>
    </div>
    
    <br>
    <div  style="margin: 1em;">
      <b-field>
        <h1><b>Top 10 kontaktov</b></h1>
      </b-field>

      <div style="height: 2em"></div>

      <ListPanelTopTen/>
    </div>

  </div>
</template>

<script>
  import ListPanelTopTen from '@/components/main/topten/ListPanelTopTen.vue';

  export default {
    components: {
      ListPanelTopTen
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    .myheaderbar {
      height: 3em;
      line-height: 3em;
      background: lightgray;
      text-align: left;
      padding-left: 1em;
    }
    .mybuttons {
      justify-content: center;
    }
</style>